import { ConversionTracker } from 'api-clients/monolith/models/ConversionTracker';

// Adzuna Tracking Pixel
export const adzunaScript = (tracker: ConversionTracker) => {
  return `<iframe src="https://www.adzuna.co.uk/app_complete/${tracker.tracking_pixel}" scrolling="no" frameborder="0" width="1" height="1"></iframe>`;
};
